import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import CardList from '../../components/CardList';
import PageTitle from '../../components/PageTitle';
import FloatingButton from '~/components/FloatingButton';
import Loading from '~/components/Loading';
import cardImages from '~/images/cardImages';

import NewTrainingRoutineDialog from './NewTrainingRoutineDialog';
import EditMenu from './EditMenu';

import { getTrainingRoutinesByUserId } from '~/api';

export default function TrainingRoutine({ match }) {
  const {
    params: { userId },
  } = match;

  const user = useSelector((state) => state.user.user);
  const isAdmin = user.role === 'ADMIN';

  const [isLoading, setIsLoading] = useState(true);
  const [allTrainingRoutines, setAllTrainingRoutines] = useState([]);
  const [editTrainingRoutineId, setEditTrainingRoutineId] = useState(null);
  const [newTrainingDialogIsOpen, setNewTrainingDialogIsOpen] = useState(false);

  // Handle the edit menu from each training routine card
  const [anchorEl, setAnchorEl] = useState(null);
  const editMenuIsOpen = !!anchorEl;

  const handleEditMenu = (event, trainingRoutine) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setEditTrainingRoutineId(trainingRoutine.id);
  };

  const history = useHistory();
  const currentURL = `/users/${userId}/training-routines`;
  const onTrainingRoutineClick = (trainingRoutine) => {
    history.push(`${currentURL}/${trainingRoutine.id}`, {
      title: trainingRoutine.title,
    });
  };

  const getAllTrainingRoutines = async () => {
    try {
      const { data: trainingRoutines } = await getTrainingRoutinesByUserId(
        userId
      );
      setAllTrainingRoutines(trainingRoutines);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllTrainingRoutines();
  }, []);

  const trainingRoutineList = allTrainingRoutines.map((trainingRoutine, i) => ({
    id: trainingRoutine.id,
    title: trainingRoutine.title,
    subtitle: trainingRoutine.finishDate
      ? `Treino finalizado em ${trainingRoutine.finishDate}`
      : 'Treino ativo',
    backgroundImage: cardImages[i % cardImages.length],
  }));

  return (
    <>
      <PageTitle>Histórico de treinos</PageTitle>
      {!isLoading ? (
        <CardList
          items={trainingRoutineList}
          emptyStateText="Não há nenhum treino no seu histórico!"
          onSelect={onTrainingRoutineClick}
          onEdit={handleEditMenu}
          isAdmin={isAdmin}
        />
      ) : (
        <Loading />
      )}

      {isAdmin && (
        <FloatingButton onClick={() => setNewTrainingDialogIsOpen(true)} />
      )}

      {/* Prevents the component to be rended without a editTrainingRoutineId */}
      {editTrainingRoutineId && (
        <EditMenu
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          isOpen={editMenuIsOpen}
          trainingRoutineId={editTrainingRoutineId}
          refreshTrainingRoutines={getAllTrainingRoutines}
        />
      )}

      <NewTrainingRoutineDialog
        isOpen={newTrainingDialogIsOpen}
        setIsOpen={setNewTrainingDialogIsOpen}
        userId={userId}
        refreshTrainingRoutines={getAllTrainingRoutines}
      />
    </>
  );
}

TrainingRoutine.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userId: PropTypes.number,
    }),
  }).isRequired,
};
